if (!customElements.get('brand-page-nav')) {
  customElements.define('brand-page-nav', class BrandPageNav extends HTMLElement {
    connectedCallback() {
      this._links = Array.from(this.querySelectorAll('.brand-nav__link'));
      this._sections = this._links
        .map(a => document.querySelector(a.getAttribute('href')))
        .filter(Boolean);

      // スムーススクロール
      this._links.forEach(a => {
        a.addEventListener('click', e => {
          e.preventDefault();
          const target = document.querySelector(a.getAttribute('href'));
          if (!target) return;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
        });
      });

      // アクティブセクション
      if (this._sections.length) {
        this._activeObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) this._setActive(entry.target.id);
          });
        }, { rootMargin: '-15% 0px -75% 0px' });
        this._sections.forEach(s => this._activeObserver.observe(s));
      }

      // sentinel (1px height で境界ブレを防ぐ)
      this._sentinel = document.createElement('div');
      this._sentinel.setAttribute('aria-hidden', 'true');
      this._sentinel.style.cssText = 'height:1px;margin:0;padding:0;';
      this.before(this._sentinel);

      // fixed 時のレイアウト崩れを防ぐ placeholder
      this._placeholder = document.createElement('div');
      this._placeholder.setAttribute('aria-hidden', 'true');
      this._placeholder.style.display = 'none';
      this.after(this._placeholder);

      this._initObserver = this._initObserver.bind(this);
      this._onResize = this._onResize.bind(this);

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this._initObserver, { once: true });
      } else {
        this._initObserver();
      }

      // resize 時にヘッダー高が変わるので observer を再生成
      window.addEventListener('resize', this._onResize);
    }

    _getHeaderHeight() {
      // fallback 100 = 10rem, matches CSS var(--header-height, 10rem)
      return (
        parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 100
      );
    }

    _initObserver() {
      this._fixObserver?.disconnect();

      const headerHeight = this._getHeaderHeight();

      this._fixObserver = new IntersectionObserver(([entry]) => {
        const scrolledPast =
          !entry.isIntersecting && entry.boundingClientRect.top < headerHeight;
        this.classList.toggle('brand-page-nav--fixed', scrolledPast);
        this._placeholder.style.cssText = scrolledPast
          ? `display:block;height:${this.getBoundingClientRect().height}px;`
          : 'display:none;';
      }, {
        threshold: 0,
        rootMargin: `-${headerHeight}px 0px 0px 0px`,
      });

      this._fixObserver.observe(this._sentinel);
    }

    _onResize() {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this._initObserver(), 150);
    }

    _setActive(id) {
      this._links.forEach(a => {
        a.classList.toggle('brand-nav__link--active', a.getAttribute('href') === '#' + id);
      });
    }

    disconnectedCallback() {
      this._activeObserver?.disconnect();
      this._fixObserver?.disconnect();
      window.removeEventListener('resize', this._onResize);
      clearTimeout(this._resizeTimer);
    }
  });
}
